import { toWidth } from "../breakpointConverter";
var isBreakpointValueFulfillingBreakpointRange = function isBreakpointValueFulfillingBreakpointRange(breakpoint, minBreakpoint, maxBreakpoint) {
  var breakpointValueAsNumber = toWidth(breakpoint);
  var isBiggerOrEqualMinBreakpoint = breakpointValueAsNumber >= toWidth(minBreakpoint);
  if (maxBreakpoint) {
    return isBiggerOrEqualMinBreakpoint && breakpointValueAsNumber < toWidth(maxBreakpoint);
  }
  return isBiggerOrEqualMinBreakpoint;
};
export default isBreakpointValueFulfillingBreakpointRange;